import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Flame } from 'lucide-react';
export function Oferta1la1Pricing() {
  const singleInclusions = ['O ședință individuală de 60-75 de minute', 'Dialog inițial pentru a identifica tema', 'Lucru direct cu credința-cheie din subconștient', 'Tehnică Theta Healing® aplicată în siguranță', 'Afirmații și pași personalizați pentru integrare'];
  const packageInclusions = ['Pachet de 6 ședințe individuale (60-75 min fiecare)', 'Traseu personalizat pe parcursul a 6-12 săptămâni', 'Lucru aprofundat pe teme multiple', 'Susținere energetică între ședințe', 'Acces direct pentru întrebări scurte între întâlniri', 'Afirmații, meditații și exerciții personalizate'];
  return <section id="oferte" className="py-24 lg:py-32 bg-[#4F2E7E] relative scroll-mt-24 overflow-hidden" data-id="element-1761">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/10 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-1762" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-gold/5 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-1763" />

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-1764">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-1765">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 text-balance" data-id="element-1766">
            Alege varianta potrivită pentru tine
          </h2>
          <div className="h-1 w-24 bg-brand-gold rounded-full mx-auto mb-6" data-id="element-1767" />
          <p className="text-white/80 text-lg max-w-2xl mx-auto" data-id="element-1768">
            O singură ședință te ajută pe o temă specifică. Pachetul de 6 e
            recomandat pentru lucru profund și schimbări durabile.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12" data-id="element-1769">
          {/* Single Session */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="bg-white rounded-[2rem] p-8 md:p-10 shadow-2xl flex flex-col" data-id="element-1770">
            <div className="mb-6" data-id="element-1771">
              <span className="inline-block text-xs uppercase tracking-wider font-bold text-brand-purple bg-brand-purple/10 px-3 py-1 rounded-full mb-3" data-id="element-1772">
                Sesiune Individuală
              </span>
              <h3 className="font-heading font-bold text-2xl text-brand-text mb-2" data-id="element-1773">
                Ședință 1 la 1 de Theta Healing®
              </h3>
              <p className="text-brand-textSec text-sm" data-id="element-1774">
                O întâlnire dedicată unei teme specifice
              </p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-1775">
              {singleInclusions.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-1776">
                  <div className="mt-1 bg-brand-gold/20 rounded-full p-1 flex-shrink-0" data-id="element-1777">
                    <Check className="w-4 h-4 text-brand-gold" data-id="element-1778" />
                  </div>
                  <span className="text-brand-text/80 text-sm" data-id="element-1779">{item}</span>
                </li>)}
            </ul>

            <div className="p-4 bg-brand-cream rounded-2xl mb-4 text-center" data-id="element-1780">
              <span className="block text-xs text-brand-textSec uppercase tracking-wider font-bold mb-1" data-id="element-1781">
                Preț special
              </span>
              <div className="flex items-baseline gap-3 justify-center" data-id="element-1782">
                <span className="text-brand-text/40 line-through text-xl decoration-2" data-id="element-1783">
                  500 lei
                </span>
                <span className="text-4xl md:text-5xl font-heading font-bold text-brand-gold" data-id="element-1784">
                  300
                </span>
                <span className="text-xl font-bold text-brand-gold" data-id="element-1785">lei</span>
              </div>
              <span className="inline-block mt-2 text-xs font-bold text-green-600 bg-green-100 px-3 py-1 rounded-full" data-id="element-1786">
                Economisești 200 lei
              </span>
            </div>

            <a href="https://link.apisystem.tech/widget/form/805WfW4vjh3X8dxEvPYb" target="_top" className="group flex items-center justify-center gap-3 w-full bg-brand-purple text-white font-heading font-bold text-lg py-4 rounded-2xl hover:bg-brand-gold transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1" data-id="element-1787">
              Rezervă o Ședință
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1788" />
            </a>
          </motion.div>

          {/* 6-Session Package */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="bg-gradient-to-br from-brand-text to-brand-purple rounded-[2rem] p-8 md:p-10 shadow-2xl text-white flex flex-col relative overflow-hidden" data-id="element-1789">
            <div className="absolute top-0 right-0 w-48 h-48 bg-brand-gold/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-1790" />
            <div className="relative flex-grow flex flex-col" data-id="element-1791">
              <div className="mb-6" data-id="element-1792">
                <span className="inline-flex items-center gap-1 text-xs uppercase tracking-wider font-bold text-brand-text bg-brand-gold px-3 py-1 rounded-full mb-3" data-id="element-1793">
                  <Flame className="w-3 h-3" data-id="element-1794" />
                  Cea mai eficientă
                </span>
                <h3 className="font-heading font-bold text-2xl mb-2 text-white" data-id="element-1795">
                  Pachet 6 Ședințe 1 la 1
                </h3>
                <p className="text-white/90 text-sm" data-id="element-1796">
                  Traseu personalizat pentru transformare profundă
                </p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-1797">
                {packageInclusions.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-1798">
                    <div className="mt-1 bg-brand-gold/20 rounded-full p-1 flex-shrink-0" data-id="element-1799">
                      <Check className="w-4 h-4 text-brand-gold" data-id="element-1800" />
                    </div>
                    <span className="text-white/90 text-sm" data-id="element-1801">{item}</span>
                  </li>)}
              </ul>

              <div className="p-4 bg-white/10 backdrop-blur-sm rounded-2xl mb-4 text-center border border-white/20" data-id="element-1802">
                <span className="block text-xs text-white/70 uppercase tracking-wider font-bold mb-1" data-id="element-1803">
                  Preț special pachet
                </span>
                <div className="flex items-baseline gap-3 justify-center" data-id="element-1804">
                  <span className="text-white/50 line-through text-xl decoration-2" data-id="element-1805">
                    1.800 lei
                  </span>
                  <span className="text-4xl md:text-5xl font-heading font-bold text-brand-gold" data-id="element-1806">
                    1.200
                  </span>
                  <span className="text-xl font-bold text-brand-gold" data-id="element-1807">lei</span>
                </div>
                <span className="inline-block mt-2 text-xs font-bold text-brand-text bg-brand-gold px-3 py-1 rounded-full" data-id="element-1808">
                  Economisești 600 lei
                </span>
              </div>

              <a href="https://link.apisystem.tech/widget/form/805WfW4vjh3X8dxEvPYb" target="_top" className="group flex items-center justify-center gap-3 w-full bg-brand-gold text-brand-text font-heading font-bold text-lg py-4 rounded-2xl hover:bg-white transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1" data-id="element-1809">
                Rezervă Pachetul de 6
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1810" />
              </a>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center text-white/90" data-id="element-1811">
          <p className="text-sm md:text-base leading-relaxed" data-id="element-1812">
            Ședințele se desfășoară online sau la cabinet (după preferință).
            Programarea se face în maximum 7 zile de la achitare. Membrii
            Academiei beneficiază de reducere suplimentară de 20%.
          </p>
        </motion.div>
      </div>
    </section>;
}